// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

 
 
export async function fetchLogin(params?: { [key: string]: any }) {
  return request<Record<string, any>>('/wrs/userLogin/login', {
    method: 'POST',
    data:params
  });
}

export async function generateVerificationCode(params?: { [key: string]: any }) {
  return request<Record<string, any>>('/wrs/userLogin/generateVerificationCode', {
    method: 'get'
  });
}

export async function changePasswordOnFirstLogin(params?: { [key: string]: any }) {
  return request<Record<string, any>>('/wrs/sysUser/changePasswordOnFirstLogin', {
    method: 'POST',
    data:params
  });
}
//修改密码
export async function changePasswordApi(params?: { [key: string]: any }) {
  return request<Record<string, any>>('/wrs/sysUser/changePassword', {
    method: 'POST',
    data:params
  });
}
